import axios from 'axios';
import store from '../redux/store/store';

const API_XML_URL = import.meta.env.VITE_API_URL;

const xmlService = {
  addMarketPlaceBrand: async (request, token) => {
    try {
      
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_XML_URL}/MarketPlaceBrand`,
        request,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("marka eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  fetchMarketPlaceBrand: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/MarketPlaceBrand`,{headers:{  Authorization: `Bearer ${userToken}`}});
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },



  deleteMarketPlaceBrand: async (id,token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
        const response = await axios.delete(`/MarketPlaceBrand`, {
            params: { id } ,
            headers:{  Authorization: `Bearer ${userToken}`}
        });
        return response;
    } catch (error) {
        console.error('Error deleting MarketPlaceBrand:', error);
        throw error;
    }
},

 
}
export default xmlService;
